import {
  CreateMultipleBookingParams,
  checkConsistencyStatus,
} from "@rentablo/api/apiv1";
import { withToken } from "@rentablo/api";

export const checkBookingConsistency = (params: CreateMultipleBookingParams) =>
  withToken(checkConsistencyStatus)({
    createOrUpdateInvestmentParamsList: {
      createOrUpdateInvestmentParamsList:
        params.createOrUpdateInvestmentParamsList,
    },
  });
